// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","links":"Header_links__W4UhB","link":"Header_link__xIhZh","menu-btn":"Header_menu-btn__8gfvJ"};